import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@jobcase/react_pattern_library/components/Typography/TypographyRebrand';
import rebrandStyles from '@jobcase/react_pattern_library/styles/rebrand';

import MobileModal from '../MobileModal/MobileModalRebrand';
import MobileModalHeader from '../MobileModalHeader/MobileModalHeaderRebrand';

const EmployerOverlay = ({
  isMobile,
  isVisible,
  onClose,
  onClickBack,
  headerText,
  secondaryHeaderText,
  secondaryOnClick,
  secondaryHeaderTextClass,
  children,
  className,
  hasBlurredMask,
  isHeaderVisible,
}) => (
  <MobileModal
    backgroundColor={rebrandStyles.color.whiteText}
    className={className}
    onClose={onClose}
    hasBlurredMask={hasBlurredMask}
    isMobile={isMobile}
    isVisible={isVisible}
  >
    {isHeaderVisible && (
      <MobileModalHeader
        headerText={headerText}
        headerTextVariant={Typography.VARIANTS.H2}
        onClickBack={onClickBack}
        onClickSecondaryText={secondaryOnClick}
        onClickClose={onClose}
        secondaryText={secondaryHeaderText}
        secondaryTextClass={secondaryHeaderTextClass}
      />
    )}
    {children}
  </MobileModal>
);

EmployerOverlay.propTypes = {
  children: PropTypes.node,

  className: PropTypes.string,
  headerText: PropTypes.string,
  secondaryHeaderText: PropTypes.string,
  secondaryHeaderTextClass: PropTypes.string,

  onClose: PropTypes.func,
  onClickBack: PropTypes.func,
  secondaryOnClick: PropTypes.func,

  hasBlurredMask: PropTypes.bool,
  isMobile: PropTypes.bool,
  isVisible: PropTypes.bool,
  isHeaderVisible: PropTypes.bool,
};

EmployerOverlay.defaultProps = {
  children: null,

  className: null,
  headerText: null,
  secondaryHeaderText: null,
  secondaryHeaderTextClass: null,

  onClose: null,
  onClickBack: null,
  secondaryOnClick: () => {},

  hasBlurredMask: false,
  isMobile: false,
  isVisible: false,
  isHeaderVisible: true,
};

export default EmployerOverlay;
